import React from 'react';
import NovemberElectionPage from '../elections/NovemberElectionPage';

const KnoxPage = () => <NovemberElectionPage defaultCounty="knox" />;

export default KnoxPage;
